import { Input, Modal, notification } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { MyModal } from "../../../components/styled-components";

interface MyModalProps {
  visible: boolean;
  onClose: () => void;
  onMatch: () => void;
  trackingNo?: string;
  orderNo?: string;
}

const ConfirmCancelSo: React.FC<MyModalProps> = ({
  visible,
  onClose,
  onMatch,
  trackingNo,
  orderNo,
}) => {
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [isMatchSuccess, setIsMatchSuccess] = useState(false); // Success state
  const inputRef = useRef<any>(null);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserInput(e.target.value);
  };

  useEffect(() => {
    if (!visible) {
      setUserInput("");
      setIsLoading(false);
      setIsMatchSuccess(false); // Reset success state when modal is closed
    } else if (visible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [visible]);

  const checkMatch = () => {
    setIsLoading(true); // Start loading
    const isMatch = trackingNo === userInput || orderNo === userInput;
    if (isMatch) {
      setIsMatchSuccess(true); // Set success state
      onMatch();
    } else {
      notification.warning({
        message: "ข้อมูลไม่ถูกต้อง",
        description: "กรุณาใส่เลข Tracking หรือ Order ใหม่",
        duration: 4,
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }

      setIsLoading(false); // Stop loading if not a match
    }

    setUserInput("");
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      checkMatch();
    }
  };

  const confirmClose = () => {
    Modal.confirm({
      title: "ต้องการปิดหน้าต่างนี้ไหม",
      content: "order นี้จะไม่ถูกยกเลิก SO!!",
      onOk() {
        setUserInput("");
        onClose();
      },
      onCancel() {
        console.log("Cancel close");
      },
    });
  };

  return (
    <MyModal
      title="กรุณาสแกนใบปะหน้าเพื่อยืนยัน !!"
      visible={visible}
      onOk={() => checkMatch()}
      onCancel={() => confirmClose()}
      okText="OK"
      cancelText="Cancel"
      confirmLoading={isLoading}
      okButtonProps={{ disabled: isMatchSuccess }} // Disable Ok button on success
      cancelButtonProps={{ disabled: isMatchSuccess }} // Disable Cancel button on success
    >
      <div>
        <Input
          value={userInput}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          ref={inputRef}
          disabled={isLoading || isMatchSuccess} // Optionally disable input on success or loading
        />
      </div>
    </MyModal>
  );
};

export default ConfirmCancelSo;
